import FeaturesAreaTwoClient from "./featuresAreaCard";

const FeaturesAreaTwo = () => {
  return (
    <div className="features-area ptb-120">
      <div className="container">
        <div
          className="features-slides overflow-hidden d-md-flex"
        
        >
          <FeaturesAreaTwoClient />
        </div>
      </div>
    </div>
  );
};

export default FeaturesAreaTwo;
